import { Util } from 'src/util/util';
import { AuthenticateService } from 'src/services/authenticate.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PrescricaoQrcodeComponent } from '../../modal-components/prescricao-qrcode/prescricao-qrcode.component';
import { ModalController } from '@ionic/angular';
import { LogoutComponent } from '../../modal-components/logout-component/logout-component';

@Component({
    selector: 'item-header-component',
    templateUrl: 'item-header-component.html',
    styleUrls: ['./item-header-component.scss']
})

export class ItemHeaderComponent implements OnInit {

    // @Input() titulo: string;
    // @Input() mensagem: string;
    // @Input() imagem: string;
    // @Input() classCSS: string;

    @Output() onGoHome = new EventEmitter();
    @Input() infoUser: any = {};

    searchQuery: any;
    imgLogoApp = 'assets/imgs/sus-digital-logo.svg';
    titulo = `ProSaúde`;

    aba = 'visualizar';

    prof: any;

    constructor(
        public router: Router,
        private auth: AuthenticateService,
        private modalController: ModalController
    ) { }

    async ngOnInit() {
        console.log('ngOnInit -> ItemHeaderComponent');
        this.prof = await this.auth.getData('_pratictioner_context');
    }

    getCpfFormatado(valor: any) {
        return Util.formatarCpf(valor);
    }

    getTextFormat(text) {
        return Util.getTextFormat(text);
    }

    goHome() {
        this.router.navigateByUrl('/home');
    }

    getItems(evt) {
        console.log(evt);
    }

    selecionar(aba) {
        this.aba = aba;
        if (aba === 'visualizar') {
            this.router.navigate(['/home/pacient']);
        }
        if (aba === 'informativo') {
            this.router.navigate(['/home/informativo']);
        }
        if (aba === 'sobre') {
            this.router.navigate(['/home/sobre-sus-digital']);
        }
        if (aba === 'conteudos') {
            this.router.navigate(['/home/conteudos']);
        }
    }

    async logoutModal() {
        const modal = await this.modalController.create({
            component: LogoutComponent,
            keyboardClose: true,
            cssClass: 'modal-bottom-default',
        });

        modal.onWillDismiss().then(async (data: any) => {
            if (data.data) {
                await this.logout();
            }
        });
        return await modal.present();
    }

    async logout() {
        await this.auth.limparStorage();
    }
}
